import { filter } from 'lodash'

export const filterArray = (originalArray: any, primaryIndex: any) => {
  return filter(
    originalArray.map((entry: any, index: any) => {
      return removeEmptyStrings({ ...entry, primary: index === Number.parseInt(primaryIndex, 10) })
    }),
    entry => {
      return Object.keys(entry).length > 1
    }
  )
}

export const removeEmptyStrings = (originalObject: any) => {
  return Object.keys(originalObject).reduce((obj, key) => {
    if (originalObject[key] !== '') {
      // @ts-expect-error
      obj[key] = originalObject[key]
    }
    return obj
  }, {})
}
